export default __webpack_public_path__ + "static/media/navitas-logo.b3ef4994.png";